export default "__VITE_ASSET__C_k8dtyJ__"